import styled from "styled-components";
import Link from "next/link";
import Head from "next/head";
import Layout from "../components/Layout";

export default function ContactPage() {
  return (
    <Layout>
      <Head>
        <title>veikkanen - Contact</title>
      </Head>
      <ContactWrap>
        <IsolatedLink
          href="mailto:hello@veikkanen.com"
          target="_blank"
          rel="noreferrer"
        >
          hello@veikkanen.com
        </IsolatedLink>
        <IsolatedLink
          href="https://instagram.com/veikkanen_label"
          target="_blank"
          rel="noreferrer"
        >
          @veikkanen_label
        </IsolatedLink>
      </ContactWrap>
    </Layout>
  );
}

const ContactWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  min-height: calc(100vh - var(--gridMarginGap) * 6);

  @media screen and (min-width: 768px) {
    min-height: calc(100vh - var(--gridMarginGap) * 2);
  }
`;

export const IsolatedLink = styled.a`
  color: var(--colorContentPrimary);

  font-size: var(--step-3-5);
  font-weight: 300;

  &:hover {
    color: var(--colorContentSecondary);
    cursor: pointer;
  }
`;
